module.exports = __webpack_public_path__ + "static/img/main.208d109.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/7/main.png
// module id = hXd6
// module chunks = 1